import { EMPTY_ARRAY as o } from "../value/constants.js";
const e = Promise.resolve();
Promise.race(o);
export {
  e as ALREADY_RESOLVED_PROMISE
};
